define('Inspiredspaces.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function InspiredSpacesModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/Inspiredspaces.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    InspiredSpacesModel.prototype = Object.create(SCModel.prototype);
    InspiredSpacesModel.prototype.constructor = InspiredSpacesModel;
 
    return InspiredSpacesModel
})
